// extracted by mini-css-extract-plugin
export default {"wrapper":"_404_wrapper__wiQgA","main_text":"_404_main_text__wUmpT"};